import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { getChartsData } from '@/services/kopBrokerService';
import ShadowCard from '@/components/ShadowCard';
import { fetchOverview } from '@/slices/kopBrokerSlice';
import BoardPanel from '@/components/Cluster/BoardPanel';
import SummaryBlock from '@/components/Cluster/SummaryBlock';
import ConfigDiff from '@/components/Cluster/ConfigDiff';
import HealthGaugeBlock from '@/pages/KOPCluster/components/HealthGaugeBlock';

function Dashboard({ fetchOverview, overview, loading }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  useEffect(() => {
    if (clusterName) {
      fetchOverview(clusterName);
    }
  }, [clusterName, fetchOverview]);

  if (!clusterName) return null;

  return (
    <Loading loading={loading}>
      <Root>
        <Summary>
          <HealthGaugeBlock mode='Broker' />
          <SummaryBlock
            title='Brokers'
            theme='blue'
            info={<CountUp end={overview.activeBrokerCount || 0} duration={0.4} />}
            unit={overview.version}
          />
          <SummaryBlock
            title='Bundles'
            theme='green'
            info={<CountUp end={overview.totalBundles || 0} duration={0.4} />}
            tip='分配的Bundle个数（可进行负载均衡最小粒度）'
          />
          <SummaryBlock
            theme='yellow'
            title='连接数'
            info={<CountUp end={overview.totalConnects || 0} duration={0.4} />}
            tip='建立TCP连接个数'
          />
          <ConfigDiff
            title='Similar Config'
            theme='blue'
            correct={overview.similarConfig}
            data={overview.similarConfigVOList || []}
          />
        </Summary>
        <BoardPanel
          style={{ flex: 1, width: 0, marginTop: -14 }}
          getChartsData={async (params) => await getChartsData({ clusterName, ...params })}
        />
      </Root>
    </Loading>
  );
}

export default connect(
  (state) => ({
    overview: state.kopBroker.overview,
    loading: state.kopBroker.loading,
  }),
  {
    fetchOverview,
  },
)(Dashboard);

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  padding-right: 20px;
`;

const Summary = styled(ShadowCard)`
  width: 260px;
  margin-right: 16px;
`;
